import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, take } from "rxjs";
import { ApiService } from "./api.service";
import { ToastService } from "./toast.service";
import { LogoUtils } from "shared/utils/logo.utils";
import { APIResponse } from "shared/models/api-response";
import { Settings, UserSettings } from "shared/models/user-settings.model";
import { Utils } from "shared/utils/utils";
import { ObjectUtils } from "shared/utils/object.utils";

@Injectable({
    providedIn: 'root'
})
export class SettingsService implements OnDestroy {

    private _userSettings:any = new BehaviorSubject<UserSettings | any>(new UserSettings());
    public currentUserSettings = this._userSettings.asObservable();
    private _pollInterval: any = null;

    constructor(
        private _apiService:ApiService,
        private _toastService:ToastService
    ) { }

    ngOnDestroy(): void {
        this.stopPolling();
    }

    /** Start polling settings every 60 seconds to pick up permission changes */
    public startPolling(): void {
        this.stopPolling();
        this._pollInterval = setInterval(() => this.refreshSettings(), 60_000);
    }

    /** Stop settings polling */
    public stopPolling(): void {
        if (this._pollInterval) {
            clearInterval(this._pollInterval);
            this._pollInterval = null;
        }
    }

    public refreshSettings() {
        this._apiService.getUserSettings()
        .pipe(take(1))
        .subscribe({
            next: async (response:APIResponse) => {

                if(response.success == false) { 
                    this._toastService.warning(response.message)
                    return
                }
                
                if(response.success == true) {

                   
                    await this.updateUserSettings(response.data);

                }

                
            }
            
        })
    }
    
    public getUserSettings(): Observable<UserSettings> {
        return this._userSettings;
    }

    async updateUserSettings(userSettings:UserSettings | any)
    {
        // Map top-level permissions into user object so all consumers can read user.permissions
        if (userSettings?.permissions && userSettings?.user) {
            userSettings.user.permissions = userSettings.permissions;
        }

        const logoUrl = ObjectUtils.getNestedValue(userSettings, 'company.logoUrl')
        await LogoUtils.getLogo(logoUrl).then(data => {
            userSettings.company.logo = data
        })

        this._userSettings.next(userSettings);
    }

    updateSettings(settings:string | Settings)
    {
        if(!Utils.isNullOrEmpty(settings)) settings = Utils.parseJSONToClass(<string>settings, Settings) || new Settings();
        this._userSettings.value.settings = <Settings>settings;
    }
}